import type { CreateIssueReportBody } from "Infrastructure/ApiZfp/Schema";
import { CreateIssueReportBodyDevice } from "Infrastructure/ApiZfp/Schema";
import UAParser from "ua-parser-js";

type ClientEnvironment = Pick<CreateIssueReportBody, "browser" | "os" | "device" | "userAgent">;

const joinDefined = (...parts: (string | undefined)[]) => parts.filter(Boolean).join(" ");

// ua-parser leaves device.type undefined for desktops and also reports types the BE doesn't know (console, smarttv, ...)
const toDevice = (type: string | undefined): CreateIssueReportBodyDevice => {
  if (type === CreateIssueReportBodyDevice.mobile) return CreateIssueReportBodyDevice.mobile;
  if (type === CreateIssueReportBodyDevice.tablet) return CreateIssueReportBodyDevice.tablet;
  return CreateIssueReportBodyDevice.desktop;
};

export const getClientEnvironment = (): ClientEnvironment => {
  const { browser, os, device, ua } = new UAParser().getResult();

  return {
    browser: joinDefined(browser.name, browser.version),
    os: joinDefined(os.name, os.version),
    device: toDevice(device.type),
    userAgent: ua,
  };
};
